import { render, staticRenderFns } from "./changelog_manage.vue?vue&type=template&id=bcf360a2&scoped=true&"
import script from "./changelog_manage.vue?vue&type=script&lang=js&"
export * from "./changelog_manage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf360a2",
  null
  
)

export default component.exports